import React, { useState, useEffect } from "react";
import contactsChip from "../../../assets/images/contacts-chip.svg";
import messagesChip from "../../../assets/images/messages-chip.svg";
import voiceChip from "../../../assets/images/voice-chip.svg";
import customMessageChip from "../../../assets/images/custom-message-chip.svg";
import settingChip from "../../../assets/images/setting-chip.svg";
import { apiCall } from "../../../functions/utils";
import { menus } from "../../../constants/menus";
import { Link } from "react-router-dom";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Box, Button } from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { plans } from "../../../constants/plans";
import { getUserInformationAsync } from "../../../redux/action";

export default function Dashboard() {
  const authUser = useSelector((state) => state.authUser);
  const messages = useSelector((state) => state.messages);
  const notifications = useSelector((state) => state.notifications);
  const dispatch = useDispatch();
  const [chartData, setChartData] = useState([]);
  const [missedCallsCount, setMissedCallsCount] = useState(0);
  const [receivedCallsCount, setReceivedCallsCount] = useState(0);
  const [selected, setSelected] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const getAnalytics = async (filter = 0) => {
    setIsLoading(true);
    //   setAnalytics({isLoading:false, period: filter})
    const response = await apiCall(true, "POST", `/api/missedCallChartData`, {
      filter,
    });

    if (
      response &&
      response.data &&
      response.data.data &&
      response.data.data.MissedCallsCount
    )
      setMissedCallsCount(response.data.data.MissedCallsCount);
    if (
      response &&
      response.data &&
      response.data.data &&
      response.data.data.responsesCount
    )
      setReceivedCallsCount(response.data.data.responsesCount);

    var calculatedData = [];
    for (let i = 0; i < response.data.data.labels.length; i++) {
      let ob = {};
      ob.name = response.data.data.labels[i];
      ob.missed = response.data.data.voiceData[i];
      ob.received = response.data.data.messageData[i];
      calculatedData.push(ob);
    }
    setChartData(calculatedData);
    setIsLoading(false);
  };
  useEffect(() => {
    getAnalytics(selected);
  }, [selected]);

  const current_account = authUser?.user?.accounts?.find(
    (account) => account.id == authUser?.activeAccount
  );

  return (
    <>
      <div className="">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12   main-section-scroll-height">
          <div
            style={{ flexWrap: "wrap" }}
            className="d-none d-md-flex  gap-4  mt-5 "
          >
            {menus.slice(1, 6).map((menu, index) => (
              <div key={index} className="col ">
                <Link to={menu.to}>
                  <div
                    className={`heading-chip text  ${menu.classname}  d-flex align-items-center justify-content-between`}
                  >
                    <div className="text">{menu.title}</div>
                    <div className="">
                      <img src={menu.chipIcon} className="d-none d-xl-block" />
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <Box className="d-flex d-md-none  gap-1  mt-5 justify-content-between ">
            {menus.slice(1, 6).map((menu, index) => (
              <Button
                style={{ whiteSpace: "wrap" }}
                fontSize={{ base: "12px", sm: "14px" }}
                key={index}
                colorScheme="teal"
                className=" "
              >
                <Link to={menu.to}>{menu.title}</Link>
              </Button>
            ))}
          </Box>
          {notifications?.data?.length > 0 &&
            notifications?.data?.find(
              (account) => account?.account?.id == authUser?.activeAccount
            )?.account?.web_signup == 1 && (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    width: "fit-content",
                    padding: "10px",
                    borderRadius: "20px",
                    backgroundColor: "#ddddc2",
                    marginTop: "10px",
                  }}
                >
                  Usage:
                  <span style={{ marginLeft: "4px" }}>
                    {notifications?.data?.length > 0 &&
                      notifications?.data?.find(
                        (account) =>
                          account?.account?.id == authUser?.activeAccount
                      )?.account?.messages_count}
                    /
                    {
                      plans?.find(
                        (plan) =>
                          plan?.price_id == current_account?.stripe_price_id
                      )?.limit
                    }
                  </span>
                </div>
              </div>
            )}
          {!isLoading ? (
            <Box
              w="full"
              //  className="d-flex justify-content-between flex-wrap align-items-center "
            >
              <div className="d-flex align-items-center justify-content-between">
                <Box className=""></Box>
                <Box w={{ base: "100%", md: "auto" }} className="">
                  <select
                    defaultValue={selected}
                    className="form-select slider-inputs"
                    onChange={(e) => setSelected(e.target.value)}
                    aria-label="Default select example"
                  >
                    <option value="0">Last 7 days</option>
                    <option value="1">Last 15 days</option>
                    <option value="2">Last 30 days</option>
                    <option value="3">Last 90 days</option>
                    <option value="4">Last year</option>
                    <option value="5">From start of service</option>
                  </select>
                </Box>
              </div>

              <Box
                display="flex"
                mt="30px"
                gap="20px"
                flexWrap="wrap"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box ml="-40px" w={{ base: "100%", xl: "70%" }} h="400px">
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart width={500} height={500} data={chartData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="missed" stackId="a" fill="#8884d8" />
                      <Bar dataKey="received" stackId="a" fill="#82ca9d" />
                    </BarChart>
                  </ResponsiveContainer>
                </Box>
                {/* <img className="img-fluid" src={infoGraphics}/>*/}

                <Box mb={{ base: "0px", xl: "60px" }}>
                  <Box
                    display="flex"
                    flexDir="column"
                    gap={{ base: "0px", md: "20px" }}
                  >
                    <Box display="flex">
                      <div className="progress blue">
                        <p className="percent-text">{missedCallsCount}</p>
                      </div>
                      <div
                        style={{ marginTop: "26px" }}
                        className="call-type miss"
                      >
                        Missed Calls
                      </div>
                    </Box>

                    <Box display="flex">
                      <div className="progress yellow">
                        <p className="percent-text">{receivedCallsCount}</p>
                      </div>
                      <div
                        className="call-type recieve"
                        style={{ marginTop: "26px" }}
                      >
                        Responses Recieved
                      </div>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : (
            <span className="loading"></span>
          )}
        </div>
      </div>
    </>
  );
}
